export default {
  listHeaders() {
    return [
      { text: 'Proje', value: 'proje' },
      { text: 'Konu', value: 'FullName' },
      { text: 'Tedarikçi', value: 'TCIdentificationNumber' },
      { text: 'Tutar', value: 'FatherName' },
      { text: 'Birinci Seviye Onay', value: 'BirSeviyeOnay' },
      { text: 'Reddet', value: 'Buttons' },
      { text: 'Onayla', value: 'Buttons' },
    ];
  },
};
